import { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import { IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import "./OffCanvasPanel.scss";

const OffCanvasPanel = (props) => {
  const [domReady, setDomReady] = useState(false);
  const [toggled, setToggled] = useState(false);

  useEffect(() => {
    setDomReady(true);
  }, [])

  // Sets display: none initally so the panel doesn't animate on page load.
  // Once it's been toggled, add additional class '--toggled' so it animates closed properly.
  useEffect(() => {
    if (props.visible) setToggled(true);
  }, [props.visible])

  let offCanvasPanelClassName = 'off-canvas-panel';
  if (props.className) offCanvasPanelClassName += ` ${props.className}`;
  if (props.visible) offCanvasPanelClassName += ` off-canvas-panel--visible`;
  if (!props.visible) offCanvasPanelClassName += ` off-canvas-panel--hidden`;
  if (props.slideInDirection) offCanvasPanelClassName += ` off-canvas-panel--slide-in-${props.slideInDirection}`;
  if (toggled) offCanvasPanelClassName += ` off-canvas-panel--toggled`;

  const closeOffCanvasPanelHandler = () => {
    props.onCloseButtonClick();
  }

  const content = (
    <div className={offCanvasPanelClassName}>
      <div className='off-canvas-panel__close-button'>
        <IconButton onClick={closeOffCanvasPanelHandler}>
          <CloseIcon />
        </IconButton>
      </div>
      {props.children}
    </div>
  );

  return domReady ? ReactDOM.createPortal(content, document.getElementById('off-canvas-panel-hook')) : null;
  
};

export default OffCanvasPanel;